import path from 'ramda/es/path';
// import prop from 'ramda/es/prop';
// import pipe from 'ramda/es/pipe';
// import map from 'ramda/es/map';
// import values from 'ramda/es/values';
// import fromPairs from 'ramda/es/fromPairs';

import i18n from 'app/i18n';
import api from 'app/actions/api';
import { popup } from 'app/common/actions/popup';


/**
/* Подписка на приложение
*/

export const APP_SUBSCRIBE_REQUEST = 'APP_SUBSCRIBE_REQUEST';
export const APP_SUBSCRIBE_SUCCESS = 'APP_SUBSCRIBE_SUCCESS';
export const APP_SUBSCRIBE_FAILURE = 'APP_SUBSCRIBE_FAILURE';

export const appSubscribeRequest = () => ({
  type: APP_SUBSCRIBE_REQUEST,
});

export const appSubscribeSuccess = () => ({
  type: APP_SUBSCRIBE_SUCCESS,
});

export const appSubscribeFailure = payload => ({
  type: APP_SUBSCRIBE_FAILURE,
  payload,
});


const subscribe = postData => async (dispatch) => {
  dispatch(appSubscribeRequest());
  try {
    const res = await api('cabinet/subscriptions', 'post', { data: postData });
    const subs = path(['data', 'subscriptions'], res);
    if (!subs) {
      dispatch(appSubscribeFailure({ err: i18n.t('app:request_tariff_activation_failed') }));
      return false;
    }
    dispatch(appSubscribeSuccess());
    dispatch(popup(i18n.t('app:request_tariff_activation_success')));
    return true;
  } catch (error) {
    dispatch(appSubscribeFailure({ error, err: i18n.t('app:request_subscribe_change_failed') }));
    return false;
  }
  // const subs = path(['data', 'subscriptions'], res);
  // const tariffs = path(['data', 'tariffs'], res);
  // const tariffBundles = path(['data', 'bundles'], res);
  // const studentId = prop('student_id', postData);
  // const data = pipe(
  //   values,
  //   map(sub => ([
  //     path([prop('tariff_id', sub), 'service'], tariffs),
  //     { [studentId]: prop('id', sub) },
  //   ])),
  //   fromPairs
  // )(subs);
  // if (!data || !subs) {
  //   dispatch(appSubscribeFailure({ err: i18n.t('app:request_tariff_activation_failed') }));
  //   return;
  // }
  // dispatch(appSubscribeSuccess({ data, subs, tariffs, tariffBundles }));
  // dispatch(popup(i18n.t('app:request_tariff_activation_success')));
};

export const appSubscribe = (tariffId, studentId, modified) => subscribe({
  tariff_id: tariffId,
  student_id: studentId,
  activation: true,
  modified: modified || {},
});

export const bundleSubscribe = (bundleId, studentId, modified) => subscribe({
  tariff_bundle_id: bundleId,
  student_id: studentId,
  activation: true,
  modified: modified || {},
});
